import { XIcon } from "lucide-react";
import { useSidePanelStore } from "@/stores/side-panel-store";
import { SearchGrid, DetailCard } from "@/components/vehicle-stock-card";
import { useT } from "@/locale-context";
import { cn } from "@/lib/utils";

export function VehicleSidePanel({ className }: { className?: string }) {
  const content = useSidePanelStore((s) => s.content);
  const close = useSidePanelStore((s) => s.close);
  const t = useT();

  if (!content) return null;

  const title =
    content.type === "search"
      ? t("sidePanel.title")
      : t("sidePanel.vehicleDetails");

  return (
    <div
      className={cn(
        "flex flex-col overflow-hidden rounded-2xl border border-blue-100 bg-white shadow-2xl",
        className,
      )}
    >
      <div className="relative flex items-center justify-between gap-3 border-b border-blue-100 bg-white px-4 py-3">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 right-0 w-1/2"
          style={{
            background:
              "radial-gradient(ellipse at right top, rgba(88, 166, 255, 0.25) 0%, rgba(72, 255, 173, 0.12) 40%, transparent 75%)",
          }}
        />
        <span className="relative truncate font-bold text-sm text-blue-600">
          {title}
        </span>
        <button
          type="button"
          onClick={close}
          aria-label={t("sidePanel.close")}
          className="relative flex size-7 items-center justify-center rounded-full text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700"
        >
          <XIcon className="size-4" />
        </button>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-3 py-2">
        {content.type === "search" ? (
          <SearchGrid data={content.data} />
        ) : (
          <DetailCard data={content.data} />
        )}
      </div>
    </div>
  );
}
